import * as React from 'react';
import { MenuItem } from '../../../small-menu-list';
import { RoleData } from '../../interfaces';

interface Props {
  role: RoleData;
  isActive: boolean;
  onSelectRole: (role: RoleData) => void;
}

const UserRolesMenuItemComponent: React.FC<Props> = ({ role, isActive, onSelectRole }) => {
  const onSelectRoleHandler = React.useCallback(() => onSelectRole(role), [role]);
  return (
    <MenuItem
      key={role.id}
      text={role.name}
      onClick={onSelectRoleHandler}
      textColor={isActive ? 'turquoise' : 'gray'}
    />
  );
};

export const UserRolesMenuItem = React.memo(UserRolesMenuItemComponent);
